import './AdminUploadPage.less';

import { Select, Typography } from 'antd';
import React, { useCallback, useState } from 'react';

import StickyPageHeader from '../components/common/StickyPageHeader';
import RatesUpload from '../components/RatesUpload';
import { useCarriers, useShipTypes } from '../hooks/apiHooks';
import Layout from '../layout';

const AdminUploadPage = ({ disableLayout, routes }) => {
  const { allCarriers } = useCarriers();
  const { allShipTypes } = useShipTypes();
  const [selectedCarrier, setSelectedCarrier] = useState();

  const onCarrierChange = useCallback(
    (carrierId) => {
      setSelectedCarrier(allCarriers.find((c) => c.id === carrierId));
    },
    [allCarriers]
  );

  const content = (
    <>
      <StickyPageHeader isAdmin title="Upload Rates" />

      <div className="admin-upload-page__carrier-select">
        <Typography.Paragraph>Select Carrier:</Typography.Paragraph>
        <Select value={selectedCarrier?.id} onChange={onCarrierChange}>
          {allCarriers.map((carrier) => (
            <Select.Option key={carrier.id} value={carrier.id}>
              {carrier.name}
            </Select.Option>
          ))}
        </Select>
      </div>

      {selectedCarrier && (
        <RatesUpload
          selectedCarrier={selectedCarrier}
          shipTypes={allShipTypes}
        />
      )}
    </>
  );

  if (disableLayout) return content;

  return (
    <Layout
      showCarriersNavigation
      disableLoading={false}
      menuIndex={0}
      routes={routes}
    >
      {content}
    </Layout>
  );
};

export default AdminUploadPage;
